var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mask"},on:{"click":_vm.isShow}},[_c('slider',{ref:"slider",attrs:{"options":_vm.options}},_vm._l((_vm.someList),function(item,index){return _c('slideritem',{key:index,style:(item.style)},[_c('img',{attrs:{"src":item.src + '?imageView2/0/format/webp',"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }